/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      $( document ).on( 'click', '.attraction-results .load-more', function() {
        $( this ).addClass( 'is-loading' );
        filterResults( getFilters( $( this ).attr( 'data-next-page' ) ), true );
      } );

      $( document ).on( 'submit', 'form', function( e ) {
        e.preventDefault();
        filterResults( getFilters() );
      } );

      $( document ).on( 'click', '.clear-filters', function() {
        $( '.filter-wrapper input' ).prop( 'checked', false );

        window.history.replaceState( null, null, window.location.pathname );
        filterResults( getFilters() );
      } );

      $( document ).on( 'change', '.filter-wrapper input', function() {
        filterResults( getFilters() );
      } );

      function getFilters( paged = 1 ) {
        $( '.clear-filters-wrapper' ).addClass( 'hidden' );
        $( 'button[data-taxonomy] .amount' ).text( '' );
        let urlQueryString = '';

        const args = {
          paged: paged,
          tax_query: {
            relation: 'AND',
          },
        };

        $( '.filter-wrapper' ).each( function( key, filter ) {
          const taxonomy = $( filter ).find( 'button' ).attr( 'data-taxonomy' );

          if ( $( 'input[name="' + taxonomy + '"]:checked' ).length ) {
            $( '.clear-filters-wrapper' ).removeClass( 'hidden' );
            const terms = [];

            $( 'input[name="' + taxonomy + '"]:checked' ).each( function() {
              terms.push( $( this ).attr( 'data-id' ) );

              urlQueryString += '&' + taxonomy.slice( 3 ) + '[]=' + $( this ).attr( 'data-id' );
            } );

            args.tax_query[taxonomy] = {
              relation: 'OR',
              [taxonomy]: {
                taxonomy: taxonomy,
                field: 'term_id',
                terms: terms,
              },
            };

            $( filter ).find( 'button .amount' ).text( '(' + terms.length + ')' );
          }

          if ( $( '.filter-form' ).attr( 'data-attraction-location' ).length ) {
            args.tax_query.ll_attraction_location = {
              ll_attraction_location: {
                taxonomy: 'll_attraction_location',
                field: 'term_id',
                terms: [$( '.filter-form' ).attr( 'data-attraction-location' )],
              },
            };
          }
        } );

        if ( urlQueryString ) {
          window.history.replaceState( null, null, '?' + urlQueryString.slice( 1 ) );
        }

        return args;
      }

      function filterResults( args = [], appendResults = false ) {
        $( '.filter-results, .filter-form' ).addClass( 'is-loading' );
        const data = {
          'args': args,
        };

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'cpt/attractions/filter', // note that cpt/filter is the path set in our new route in routes.php
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            $( '.attraction-results .load-more-wrapper' ).hide();

            if ( appendResults ) {
              $( '.filter-results' ).append( data.results );
              $( '.attraction__card' ).magnificPopup( {
                type: 'inline',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: false,
                fixedContentPos: false,
              } );
            } else {
              $( '.filter-results' ).html( data.results );
            }

            $( '.filter-results, .filter-form' ).removeClass( 'is-loading' );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'attractions', COMPONENT );
} )( app );
